/**
 * @file 全局指令注册
 */
import Vue from 'vue'
import directives from '@/common/directives'

/**
 * 注册全局指令
 */
export function setupDirectives() {
    Vue.directive('emoj', directives.emoj)
    Vue.directive('throttle', directives.throttle)
    Vue.directive('debounce', directives.debounce)
}

